import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useToast,
} from '@ais-ui/ui-core';
import React from 'react';
import { CustomizePopover } from './CustomizePopover';
import { sogDistributionReportMiscellaneous } from '../reportsTypes';
import {
  ParsedReportParams,
  useSpeedOverGroundReconfigure,
} from '@ais-ui/websockets';
import { useFetchOverlayData } from '../useMapReportOverlay';

interface CustomizeSpeedOverGroundProps {
  report: ParsedReportParams;
  className?: string;
}

export const CustomizeSpeedOverGround = ({
  report,
  className,
}: CustomizeSpeedOverGroundProps) => {
  const fetchOverlayData = useFetchOverlayData();
  const { mutate } = useSpeedOverGroundReconfigure(fetchOverlayData);

  const [statisticGrouping, setStatisticGrouping] = React.useState(
    report.params.STG
  );
  const [interval, setInterval] = React.useState(report.params.PI);

  const { toast } = useToast();

  const onApply = () => {
    mutate(
      {
        jobId: report.info?.['Job ID'] as string,
        statisticGrouping: statisticGrouping,
        interval: interval,
      },
      {
        onSuccess: () => {
          toast({
            title: 'Success!',
            description:
              'Customized speed over ground distribution report successfully',
          });
        },
        onError: () => {
          toast({
            title: 'Error!',
            description:
              'Error customizing speed over ground distribution report',
            variant: 'destructive',
          });
        },
      }
    );
  };

  return (
    <CustomizePopover>
      <form className="grid grid-cols-2 gap-8 p-2 w-96">
        <div className="space-y-2">
          <Label htmlFor="statistic-grouping">Statistic grouping</Label>
          <Select
            value={statisticGrouping}
            onValueChange={setStatisticGrouping}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select a statistic grouping" />
            </SelectTrigger>
            <SelectContent>
              {sogDistributionReportMiscellaneous?.distribution?.options?.map(
                (statisticGroupingOption) => (
                  <SelectItem
                    key={statisticGroupingOption.value}
                    value={statisticGroupingOption.value}
                  >
                    {statisticGroupingOption.label}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="interval">Interval</Label>
          <Select value={interval} onValueChange={setInterval}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select an interval" />
            </SelectTrigger>
            <SelectContent>
              {sogDistributionReportMiscellaneous?.interval?.options?.map(
                (intervalOption) => (
                  <SelectItem
                    key={intervalOption.value}
                    value={intervalOption.value}
                  >
                    {intervalOption.label}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>
      </form>
      <div className="pt-6 flex justify-end">
        <Button onClick={onApply}>Apply</Button>
      </div>
    </CustomizePopover>
  );
};
